
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[organization]/[locale]/sitemap",
      function () {
        return require("private-next-pages/[organization]/[locale]/sitemap.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[organization]/[locale]/sitemap"])
      });
    }
  